export const SVG_TEXT_HELPER = {

  getTextWidth: function (text: string, fontSize: number): number {
    const canvas = document.createElement("canvas");
    const context: CanvasRenderingContext2D | null = canvas.getContext("2d");
    if (context == null) {
      return -1;
    }
    context.font = '500 ' + fontSize + 'px "Open Sans"';
    return context.measureText(text).width;
  },

  breakString: function (word: string, maxWidth: number, fontSize: number): {
    hyphenatedStrings: string[],
    remainingWord: string
  } {
    const characters = word.split("");
    const lines: string[] = [];
    let currentLine = "";
    characters.forEach((character, index) => {
      const nextLine = `${currentLine}${character}`;
      const lineWidth = SVG_TEXT_HELPER.getTextWidth(nextLine, fontSize);
      if (lineWidth >= maxWidth) {
        const currentCharacter = index + 1;
        const isLastLine = characters.length === currentCharacter;
        const hyphenatedNextLine = `${nextLine}`; // HYPHEN HERE
        lines.push(isLastLine ? nextLine : hyphenatedNextLine);
        currentLine = "";
      } else {
        currentLine = nextLine;
      }
    });
    return {hyphenatedStrings: lines, remainingWord: currentLine};
  },

  wrapLabel: function (label: string, maxWidth: number, fontSize: number) {
    if (!fontSize) {
      fontSize = 4;
    }
    var labelKey = "l:" + label + "mw:" + maxWidth + "fs:" + fontSize;
    if (labelKey in SVG_TEXT_HELPER.wrapCache) {
      return SVG_TEXT_HELPER.wrapCache[labelKey];
    }
    const words = label.split(" ");
    const completedLines: string[] = [];
    let nextLine = "";
    words.forEach((word, index) => {
      const wordLength = SVG_TEXT_HELPER.getTextWidth(`${word} `, fontSize);
      const nextLineLength = SVG_TEXT_HELPER.getTextWidth(nextLine, fontSize);
      if (wordLength > maxWidth) {
        const {hyphenatedStrings, remainingWord} = SVG_TEXT_HELPER.breakString(word, maxWidth, fontSize);
        completedLines.push(nextLine, ...hyphenatedStrings);
        nextLine = remainingWord;
      } else if (nextLineLength + wordLength >= maxWidth) {
        completedLines.push(nextLine);
        nextLine = word;
      } else {
        nextLine = [nextLine, word].filter(Boolean).join(" ");
      }
      const currentWord = index + 1;
      const isLastWord = currentWord === words.length;
      if (isLastWord) {
        completedLines.push(nextLine);
      }
    });
    var res = completedLines.filter(line => line !== "");
    SVG_TEXT_HELPER.wrapCache[labelKey] = res;
    return res;
  },

  wrapLabelWithForcedLineBreak: function (label: string, maxWidth: number, fontSize: number, lineBreakChar: string) {
    var results = label.split(lineBreakChar).map(function (part) {
      return SVG_TEXT_HELPER.wrapLabel(part, maxWidth, fontSize);
    });
    return results.reduce(function (p, c) {
      return p.concat(c)
    }, []);
  },
  wrapCache: {} as Record<string, string[]>
};